import { PartnerPartnersRequest, PaginationMetaData, SubPartnerAccount } from 'vopay';
import { useCallback, useState } from 'react';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useFetchPartnerPartners() {
  const [fetching, setFetching] = useState(false);
  const [partners, setPartners] = useState<SubPartnerAccount[]>([]);
  const [paginationMetaData, setPaginationMetaData] = useState<PaginationMetaData>();

  const fetchPartnerPartners = useCallback(async (params: PartnerPartnersRequest) => {
    try {
      setFetching(true);
      const res = await api.fetchPartnerPartners(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setPartners(res.Partners);
      setPaginationMetaData(res.PaginationMetaData);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }, []);

  return { fetching, partners, paginationMetaData, fetchPartnerPartners };
}
